module.exports = __webpack_public_path__ + "static/media/Coffee_Thumb_1.cd7feddb.jpg";